<template>
  <li v-if="displayType == 'thumbnail'" class="drag-li item-li"
      @click="getPath(file); userClicked(file);"
      @drag="drag(file)"
      ondragstart="event.dataTransfer.setData('text',''); this.style.backgroundColor = '#5bc0de';"
      ondragend="this.style.backgroundColor = 'transparent'"
      draggable="true"
      :id="file.name"
  >
    <br/>
    <div v-bind:key="file.id"
         :id="'media_file_' + file.id"
         class="file scale"
         style="position:relative;"
         :data-file_id="file.id"
         :data-user_id_file="file.custom_properties.uploader"
    >
      <p class="fileName">{{ file.file_name }}</p>

      <template v-if="document_preview_disabled !== 'true' && showPreviewButton(file.mime_type)">
        <a v-if="file.mime_type == 'video/mp4'"
                :data-fancybox="true"
                :data-caption="file.name"
                v-bind:href="'#video_' + file.id"
                v-html="getTheIcon(file.mime_type, file, clientID)"
                class="image-icon-container"
                tabindex="-1"
                :aria-label="file.file_name"
        ></a>
        <a v-else
                :data-fancybox="!newTabActionFiles(file.mime_type)"
                :data-caption="file.name"
                :target="newTabActionFiles(file.mime_type) ? '_blank' : ''"
                v-bind:href="getImageLink(certificates, file, clientID)"
                v-html="getTheIcon(file.mime_type, file, clientID)"
                class="image-icon-container"
                tabindex="-1"
                :aria-label="file.file_name"
        ></a>
      </template>

      <template v-else>

        <template v-if="!file.is_pdf_learning_unit">
          <a class="image-icon-container"
                  v-bind:target="newTabActionFiles(file.mime_type) ? '_blank' : ''"
                  v-bind:href="'/media/file/'+ getDownloadPath(file, clientID) "
                  v-html="getTheIcon(file.mime_type, file, clientID)"
                  tabindex="-1"
                  :aria-label=" trans('lms.Download')+ ' ' + file.file_name"
          ></a>
        </template>

        <!--  PDF DOCUMENT    -->
        <template v-else>
          <a class="image-icon-container"
             :aria-label="file.file_name"
             @click.prevent="openPdfUnit(file)"
              v-html="getTheIcon(file.mime_type, file, clientID)"
          ></a>
        </template>

      </template>

      <template v-if="!file.is_pdf_learning_unit">

        <template v-if="document_preview_disabled !== 'true'">
          <a v-if="(!certificates && showPreviewButton(file.mime_type))"
                  :data-fancybox="showPreviewButton(file.mime_type) ?  'eye' : false " :data-caption="file.name"
                  :target="newTabActionFiles(file.mime_type) ? '_blank' : ''"
                  v-bind:href="'/storage/' + getFilePath(file, clientID)"
                  role="button"
                  tabindex="0"
                  :aria-label="trans('lms.Preview') + ' ' + file.file_name"
          >
            <span class="glyphicon glyphicon-eye-open main_text"></span>
          </a>
        </template>

        <template v-else>
          <a v-if="!certificates && showPreviewButton(file.mime_type)"
                  :target="newTabActionFiles(file.mime_type) ? '_blank' : ''"
                  v-bind:href="'/media/file/'+ getDownloadPath(file, clientID) "
                  role="button"
                  tabindex="0"
                  :aria-label="trans('lms.Preview') + ' ' + file.file_name"
          >
            <span class="glyphicon glyphicon-eye-open main_text"></span>
          </a>
        </template>

        <a v-if="!certificates" :href="'/media/file/' + getDownloadPath(file, clientID)"
                role="button"
                tabindex="0"
                :aria-label="trans('lms.Download') + ' ' + file.file_name"
        >
          <span class="glyphicon glyphicon-download-alt main_text"></span>
        </a>

        <template v-if="isAdmin && file.deletable_and_editable != 'false' && !show ">
          <button v-if="!certificates && file.deletable_and_editable === 1 && !show "
                  v-on:click="confirmDeletion(file.delete_id, file.id) "
                  role="button"
                  tabindex="0"
                  :aria-label="trans('lms.Remove') + ' ' + file.file_name"
          >
            <span class="glyphicon glyphicon-trash main_text"></span>
          </button>

          <button v-if="!certificates && file.deletable_and_editable === 1 && !show " @click="showModal(file)"
                  role="button"
                  tabindex="0"
                  :aria-label="trans('lms.Edited') + ' ' + file.file_name">
            <span class="glyphicon glyphicon-cog main_text"></span>
          </button>
        </template>

        <button v-if="!certificates && !show" @click="showInfo(file)"
                role="button"
                tabindex="0"
                :aria-label="trans('lms.Info') + ' ' + file.file_name"
        >
          <span class="glyphicon glyphicon-info-sign main_text"></span>
        </button>

        <StatisticsButton v-if="isFrontend == false && displayType != 'ckeditor' && !show " :file_id="file.id"
                          :file_name="file.name " :view="thumbnail"/>
        <i v-if="dataSeen && !file.isLearningUnit" class="fa fa-check-square-o"
           style="position:absolute;right:.1875rem;bottom:.125rem;font-size:1.25rem"></i>

      </template>

      <!--  PDF DOCUMENT    -->
      <template v-else>
        <button v-on:click="confirmDeletionPdf(file.delete_id) "
                role="button"
                tabindex="0"
                :aria-label="trans('lms.Remove') + ' ' + file.file_name"
        >
          <span class="glyphicon glyphicon-trash main_text"></span>
        </button>

        <button v-if="!certificates && !show" @click="showInfo(file)"
                role="button"
                tabindex="0"
                :aria-label="trans('lms.Info') + ' ' + file.file_name"
        >
          <span class="glyphicon glyphicon-info-sign main_text"></span>
        </button>
      </template>

    </div>
  </li>
  <tr v-else
      v-bind:key="file.id"

      class="drag-li file-tr"
      @click="getPath(file); userClicked(file);"
      @drag="drag(file)"
      ondragstart="event.dataTransfer.setData('text',''); this.style.backgroundColor = '#5bc0de';"
      ondragend="this.style.backgroundColor = 'transparent'"
      draggable="true"
      :id="'media_file_' + file.id"
      :data-file_id="file.id"
      :data-user_id_filetr="file.custom_properties.uploader"
  >
    <td class="document_view_td cutName" draggable="true">
      <template>{{ file.file_name }}</template>
    </td>

        <td class="document_view_td">
            {{ file.formated_date }}
        </td>

    <td class="document_view_td">
      {{ formatDate(file.created_at) }}
    </td>

    <td class="document_view_td" v-html="getAuthor(file['author_with_image'])"></td>

    <td class="document_view_td">
      {{ Math.ceil(file.size / 1024) + "KB" }}
    </td>

    <td class="document_view_td">
      {{ file.info["description"] }}
    </td>

    <td v-if="!file.is_pdf_learning_unit" class="document_view_td">

      <template v-if="document_preview_disabled !== 'true'">
        <a v-if="!certificates && showPreviewButton(file.mime_type)"
           :data-fancybox="showPreviewButton(file.mime_type) ? 'eye' : false"
           :data-caption="file.file_name"
           :target="newTabActionFiles(file.mime_type) ? '_blank' : ''"
           v-bind:href="'/storage/' + getFilePath(file, clientID)"
           role="button"
           :aria-label="trans('lms.Preview') + ' ' + file.file_name">
          <span class="glyphicon glyphicon-eye-open main_text"></span>
        </a>
      </template>
      <template v-else>
        <a v-if="!certificates && showPreviewButton(file.mime_type)"
           :target="newTabActionFiles(file.mime_type) ? '_blank' : ''"
           v-bind:href="'/media/file/' + getDownloadPath(file, clientID)"
           role="button"
           :aria-label="trans('lms.Preview') + ' ' + file.file_name">
          <span class="glyphicon glyphicon-eye-open main_text"></span>
        </a>
      </template>
      <a v-if="!certificates"
         :href="'/media/file/' + getDownloadPath(file, clientID)"
         role="button"
         :aria-label="trans('lms.Download') + ' ' + file.file_name">
        <span class="glyphicon glyphicon-download-alt main_text"></span>
      </a>
      <template v-if="isAdmin && file.deletable_and_editable != 'false'">
        <button v-if="!certificates && file.deletable_and_editable === 1 && !show"
                v-on:click="confirmDeletion(file.delete_id, file.id)"
                type="button"
                :aria-label="trans('lms.Remove') + ' ' + file.file_name">
          <span class="glyphicon glyphicon-trash main_text"></span>
        </button>
        <button v-if="!certificates && file.deletable_and_editable === 1 && !show"
                @click="showModal(file)"
                type="button"
                :aria-label="trans('lms.Edited') + ' ' + file.file_name">
          <span class="glyphicon glyphicon-cog main_text"></span>
        </button>
      </template>
      <button v-if="!certificates && !show"
              @click="showInfo(file)"
              type="button"
              :aria-label="trans('lms.Info') + ' ' + file.file_name">
        <span class="glyphicon glyphicon-info-sign main_text"></span>
      </button>
      <StatisticsButton v-if="isFrontend == false && displayType != 'ckeditor' && !show"
                        :file_id="file.id"
                        :file_name="file.name"
                        :view="table"/>

    </td>

    <!--  PDF DOCUMENT    -->
    <td v-else>
      <button v-on:click="confirmDeletionPdf(file.delete_id) "
              role="button"
              tabindex="0"
              :aria-label="trans('lms.Remove') + ' ' + file.file_name"
      >
        <span class="glyphicon glyphicon-trash main_text"></span>
      </button>

      <button v-if="!certificates && !show" @click="showInfo(file)"
              role="button"
              tabindex="0"
              :aria-label="trans('lms.Info') + ' ' + file.file_name"
      >
        <span class="glyphicon glyphicon-info-sign main_text"></span>
      </button>
    </td>

  </tr>
</template>
<style scoped>
.scale {
  transition: .2s;

}

.scale:hover {
  box-shadow: 0 0 11px rgba(33, 33, 33, .2);
}

.media-video {
  width: 100%;
  max-height: 140px;
  height: 140px;
}

.mainColor {
  display: block;
  width: 198px;
  height: 140px;
  font-size: 100px;
  margin-bottom: 5px !important;
  padding: 20px;
  color: var(--main-icon-color);
}

.file a {
  cursor: pointer;
}

button .file {
  text-align: center;
}

button {
  background: none;
  border-style: none;
  border: none;
  box-sizing: content-box;
  cursor: pointer;
  display: inline;
  font: inherit;
  height: auto;
  padding: 0;
  perspective-origin: 0 0;
  text-align: start;
  transform-origin: 0 0;
  width: auto;
}
</style>
<script>
import Bus from "../bus";
import StatisticsButton from "./statisticsbutton";

export default {
  props: ["file", "document_preview_disabled", "prevent_preview", "displayType", "certificates", "isAdmin", "isFrontend", "seen", "showModal", "showInfo", "show",],
  components: {
    StatisticsButton
  },
  data() {
    return {
      clientID: localStorage.getItem("clientID"),
      dataSeen: this.seen,
    };
  },
  methods: {

    newTabActionFiles(mimetype) {
      if (this.prevent_preview == "true") {
        return false;
      }
      if (this.displayType == "ckeditor") {
        return false;
      }
      switch (mimetype) {
        case "application/pdf":
          return true;
        case "application/zip":
          return true;
        case "video/mp4":
          return false;
        case "image/tiff":
          return true;
        default:
          return false;
      }
    },
    getAuthor(author) {
      return `${author}`
    },
    getImageLink(certificates, file, clientID) {
      if (certificates || this.prevent_preview == "true") {
        return "#";
      }
      return "/storage/" + this.getFilePath(file, clientID);
    },
    getFilePath(file, clientID) {
      file.id = file.url_id ? file.url_id : file.id;
      if (file.info.client_id != clientID) {
        clientID = file.info.client_id;
      }
      let model = "";
      if (undefined !== file.model_type) {
        if (file.model_type == "series") {
          model = "series";
        } else if (file.model_type == "learning_box") {
            model = "learning_box";
        } else if (
          file.model_type !== "seminar" &&
          file.model_type !== "course" &&
          file.model_type !== "series" &&
          file.model_type !== "feedback" &&
          file.model_type !== "unit_template" &&
          file.model_type !== "office_document" &&
          file.model_type !== "content_media" &&
          file.model_type !== "pdfdocument" &&
          file.model_type !== "test" &&
          file.model_type !== "page" &&
          file.model_type !== "h5p" &&
          file.model_type !== "external_content" &&
          file.model_type !== "App\\User"
        ) {
          model = file.model_type.replace("App\\", "").replace(/\\/g, "/").toLowerCase() + "s";
        } else if (file.model_type == "App\\User") {
          model = 'users_pictures';
        } else {
          model = file.model_type.toLowerCase();
        }

        if (file.old_path_generation === 1) {
          if (file.model_type === 'office_document') {
            model = 'contentpresentations';
          } else if (file.model_type === 'course') {
            model = 'courses';
          } else if (file.model_type === 'seminar') {
            model = 'seminars';
          }
        }

        if (file.model_type === "App\\User") {
          clientID = null;
        }
        return [clientID, model, file.model_id, file.id, file.file_name].join("/");
      }
    },
    getTheIcon(fileType, file, clientID) {

      switch (fileType) {
        case "image/png":
          if (this.displayType == "table") {
            return '<i class="fa fa-file-image-o" aria-hidden="true"></i>';
          }
          if (this.document_preview_disabled == "true") {
            return '<i class="fa fa-file-image-o mainColor" aria-hidden="true"></i>';
          }
          return (
              '<img class="file-image" src="/storage/' + this.getFilePath(file, clientID) + '">'
          );
        case "image/jpg":
          if (this.displayType == "table") {
            return '<i class="fa fa-file-image-o" aria-hidden="true"></i>';
          }

          if (this.document_preview_disabled == "true") {
            return '<i class="fa fa-file-image-o mainColor" aria-hidden="true"></i>';
          }

          return (
              '<img class="file-image" src="/storage/' + this.getFilePath(file, clientID) + '">'
          );
        case "image/jpeg":
          if (this.displayType == "table") {
            return '<i class="fa fa-file-image-o" aria-hidden="true"></i>';
          }

          if (this.document_preview_disabled == "true") {
            return '<i class="fa fa-file-image-o mainColor" aria-hidden="true"></i>';
          }

          return (
              '<img class="file-image" src="/storage/' + this.getFilePath(file, clientID) + '">'
          );
        case "image/bmp":
          if (this.displayType == "table") {
            return '<i class="fa fa-file-image-o" aria-hidden="true"></i>';
          }

          if (this.document_preview_disabled == "true") {
            return '<i class="fa fa-file-image-o mainColor" aria-hidden="true"></i>';
          }

          return (
              '<img class="file-image" src="/storage/' + this.getFilePath(file, clientID) + '">'
          );
        case "application/pdf":
          if (this.displayType == "table") {
            return '<i class="fa fa-file-pdf-o" aria-hidden="true"></i>';
          }
          return '<i class="fa fa-file-pdf-o mainColor" aria-hidden="true"></i>';
        case "application/vnd.ms-powerpoint":
          if (this.displayType == "table") {
            return '<i class="fa fa-file-powerpoint-o" aria-hidden="true">';
          }
          return '<i class="fa fa-file-powerpoint-o mainColor" aria-hidden="true">';
        case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
          if (this.displayType == "table") {
            return '<i class="fa fa-file-powerpoint-o" aria-hidden="true">';
          }
          return '<i class="fa fa-file-powerpoint-o mainColor" aria-hidden="true">';
        case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
          if (this.displayType == "table") {
            return '<i class="fa fa-file-excel-o" aria-hidden="true"></i>';
          }
          return '<i class="fa fa-file-excel-o mainColor" aria-hidden="true"></i>';
        case "application/vnd.ms-excel":
          if (this.displayType == "table") {
            return '<i class="fa fa-file-excel-o" aria-hidden="true"></i>';
          }
          return '<i class="fa fa-file-excel-o mainColor" aria-hidden="true"></i>';
        case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
          if (this.displayType == "table") {
            return '<i class="fa fa-file-excel-o" aria-hidden="true"></i>';
          }
          return '<i class="fa fa-file-excel-o mainColor" aria-hidden="true"></i>';
        case "text/plain":
          if (this.displayType == "table") {
            return '<i class="fa fa-file-text-o" aria-hidden="true"></i>';
          }
          return '<i class="fa fa-file-text-o mainColor" aria-hidden="true"></i>';
        case "application/msword":
          if (this.displayType == "table") {
            return '<i class="fa fa-file-text-o" aria-hidden="true"></i>';
          }
          return '<i class="fa fa-file-text-o mainColor" aria-hidden="true"></i>';
        case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
          if (this.displayType == "table") {
            return '<i class="fa fa-file-text-o" aria-hidden="true"></i>';
          }
          return '<i class="fa fa-file-text-o mainColor" aria-hidden="true"></i>';
        case "video/mp4":
          if (this.displayType == "table") {
            return '<i class="fa fa-file-image-o" aria-hidden="true"></i>';
          }

          if (this.document_preview_disabled == "true") {
            return '<i class="fa fa-file-image-o mainColor" aria-hidden="true"></i>';
          }

          return (
              '<video class="media-video" controls><source src="' +
              this.getImageLink(false, file, clientID) +
              '" type="video/mp4"></video>' +
              '<video class="media-video fancybox-video" style="display:none" id="video_' + file.id + '"controls><source src="' +
              this.getImageLink(false, file, clientID) +
              '" type="video/mp4"></video>'
          );
        case "image/tiff":

          // if (this.displayType == "table") {
          //   return '<i class="fa fa-file-image-o" aria-hidden="true"></i>';
          // }
          //
          // if (this.document_preview_disabled == "true") {
          //   return '<i class="fa fa-file-image-o mainColor" aria-hidden="true"></i>';
          // }
          //
          // return (
          //     '<img class="file-image" src="/storage/' + this.getFilePath(file, clientID) + '">'
          // );


          if (this.displayType == "table") {
            return '<i class="fa fa-file-image-o" aria-hidden="true"></i>';
          }
          return '<i class="fa fa-file-image-o mainColor" aria-hidden="true"></i>';
        case "application/zip":
          if (this.displayType == "table") {
            return '<i class="fa fa-file-archive-o" aria-hidden="true"></i>';
          }
          return '<i class="fa fa-file-archive-o mainColor" aria-hidden="true"></i>';
        default:
          if (this.displayType == "table") {
            return '<i class="fa fa-file-o" aria-hidden="true"></i>';
          }
          return '<i class="fa fa-file-o mainColor" aria-hidden="true"></i>';
      }
    },
    showPreviewButton(mimetype) {
      if (this.prevent_preview == "true") {
        return false;
      }

      switch (mimetype) {
        case "image/png":
          return true;
        case "image/jpg":
          return true;
        case "image/jpeg":
          return true;
        case "image/bmp":
          return true;
        case "application/pdf":
          return false;
        case "application/vnd.ms-powerpoint":
          return false;
        case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
          return false;
        case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
          return false;
        case "application/vnd.ms-excel":
          return false;
        case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
          return false;
        case "text/plain":
          return false;
        case "application/msword":
          return false;
        case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
          return false;
        case "video/mp4":
          return true;
        case "image/tiff":
          return false;
        case "application/zip":
          return false;
        default:
          return false;
      }
    },
    getDownloadPath(file, clientID) {
      file.id = file.url_id ? file.url_id : file.id;

                let model = "";
                if (undefined !== file.model_type) {
                    if (file.model_type == "series") {
                        model = "series";
                    } else if (file.model_type == "learning_box") {
                      model = "learning_box";
                    } else if (
                        file.model_type !== "seminar" &&
                        file.model_type !== "course" &&
                        file.model_type !== "series" &&
                        file.model_type !== "feedback" &&
                        file.model_type !== "unit_template" &&
                        file.model_type !== "office_document" &&
                        file.model_type !== "content_media" &&
                        file.model_type !== "pdfdocument" &&
                        file.model_type !== "test" &&
                        file.model_type !== "page" &&
                        file.model_type !== "h5p" &&
                        file.model_type !== "external_content" &&
                        file.model_type !== "App\\User"
                    ) {
                        model = file.model_type.replace("App\\", "").replace(/\\/g, "/").toLowerCase() + "s";
                    } else {
                        model = file.model_type.toLowerCase();
                    }

        if (file.old_path_generation === 1) {
          if (file.model_type === 'office_document') {
            model = 'contentpresentations';
          } else if (file.model_type === 'course') {
            model = 'courses';
          } else if (file.model_type === 'seminar') {
            model = 'seminars';
          }
        }


        clientID = file.custom_properties.client_id;

        return [clientID, model, file.model_id, file.id, file.file_name].join("/");
      }
    },
    openPdfUnit(file) {
        overlayitupPdf(file.custom_properties.path, file.custom_properties.width,file.custom_properties.height, file.id, true);
    },
    getPath(file) {
      if (window.location.href.indexOf("CKEditorFuncNum") > -1) {
        event.preventDefault();
        axios
            .post(getPathRoute, {
              name: file.file_name,
              id: file.url_id ? file.url_id : file.id, // TODO check once again
              model: file.model_type,
              model_id: file.model_id,
              full_path: 0,
              _token: this.csrf,
            })
            .then((response) => {
              var funcNum = this.getUrlParam("CKEditorFuncNum");
              var fileUrl = response.data;
              window.opener.CKEDITOR.tools.callFunction(funcNum, fileUrl);
              window.close();
            });
      } else if (
          window.location.href.indexOf("certificate") > -1 ||
          window.location.href.indexOf("newsletter") > -1
      ) {
        event.preventDefault();
        axios
            .post(getPathRoute, {
              name: file.file_name,
              id: file.url_id ? file.url_id : file.id,
              model: file.model_type,
              model_id: file.model_id,
              _token: this.csrf,
            })
            .then(
                (response, fancy = document.getElementsByClassName("fancybox-is-open")[0]) => {
                  var fileUrl = response.data;
                  localStorage.setItem("id", file.id);
                  localStorage.setItem("path", fileUrl);
                  Bus.$emit("close-overlay");

                  if (fancy !== null && fancy !== undefined) {
                    fancy.parentNode.removeChild(fancy);
                  }
                }
            );
      }
    },
    userClicked(file) {
      if (event.target && event.target.classList.contains('no-click-stats')) {
        return;
      }

      let tempId = file.delete_id ? file.delete_id : file.id;
      this.dataSeen = true;
      axios.post("/media/activity", {
        media_id: tempId,
        _token: this.csrf,
      });

      if (typeof closeMediaModalOnSelect !== 'undefined' && closeMediaModalOnSelect === true) {
        if (document.getElementById('close_file_overlay') != null) {
          $('#close_file_overlay').trigger('click');
          document.getElementById('close_file_overlay').click()
        }
      }
    },
    formatDate(date) {
      let newDate = new Date(date);
      if (isNaN(Date.parse(date))) {
        return date;
      }
      let locale = document.documentElement.lang;
      return newDate.toLocaleString(locale);
    },
    drag(ev) {
      if (localStorage.getItem("media_id")) {
        localStorage.removeItem("media_id");
        localStorage.setItem("media_id", ev.id);
      }
      localStorage.setItem("media_id", ev.id);
    },
    confirmDeletion(delete_id, id) {
      if (delete_id !== undefined && delete_id !== null) {
        id = delete_id;
      }
      this.getUsedInfoList(id);
    },
    confirmDeletionPdf(id) {
      Bus.$emit('delete-pdf', [id]);
      document.getElementById('fileDeleteModal').showModal();
    },
    getUsedInfoList(id) {
      axios
          .get("/media/getusedinfo/" + id)
          .then((response) => {
            Bus.$emit('delete-file', [id, response.data.data]);
            document.getElementById('fileDeleteModal').showModal();
          });
    },
  }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/media_item.vue